export interface Palette {
    id: string;
    name: string;
    colors: string[]; // Hex codes
    materials: string[]; // Material names/descriptions
    tags: string[];
}

export const MOCK_PALETTES: Palette[] = [
    {
        id: 'p1',
        name: 'Coastal Modern',
        colors: ['#FFFFFF', '#F5F5F5', '#1E3A8A', '#D4AF37'],
        materials: ['White Stucco', 'Teak Wood', 'Ocean Glass', 'Brass Accents'],
        tags: ['coastal', 'modern', 'fresh']
    },
    {
        id: 'p2',
        name: 'Industrial Chic',
        colors: ['#374151', '#9CA3AF', '#B45309', '#000000'],
        materials: ['Exposed Brick', 'Concrete', 'Rustic Wood', 'Black Steel'],
        tags: ['industrial', 'urban', 'bold']
    },
    {
        id: 'p3',
        name: 'Scandi Minimal',
        colors: ['#F3F4F6', '#E5E7EB', '#A8A29E', '#78716C'],
        materials: ['Pale Pine', 'White Plaster', 'Wool Textures', 'Limestone'],
        tags: ['scandinavian', 'minimal', 'cozy']
    }
];
